import React from "react";
import {AbsoluteFill, Sequence, staticFile} from "remotion";
import {VideoClip} from "../../components/media/VideoClip";
import {CaptionOverlay, type CaptionPreset} from "../../components/text/CaptionOverlay";
import {AnimatedTitle} from "../../components/text/AnimatedTitle";
import {ProgressBar} from "../../components/overlays/ProgressBar";
import {SafeArea} from "../../components/layout/SafeArea";
import {Watermark} from "../../components/overlays/Watermark";
import {loadDefaultFonts} from "../../presets/fonts";
import {BRAND} from "../../presets/brand";
import {OrganicLayer} from "../../components/overlays/OrganicLayer";
import {FilmGrain as CinemaGrain, CinemaVignette} from "../../components/overlays/FilmGrain";

export interface PodcastClipProps {
  videoSrc?: string;
  clipStartSeconds?: number;
  clipEndSeconds?: number;
  captionsPath?: string;
  showCaptions?: boolean;
  captionPreset?: CaptionPreset;
  title?: string;
  accentColor?: string;
}

export const PodcastClip: React.FC<PodcastClipProps> = ({
  videoSrc = "assets/video.mp4",
  clipStartSeconds = 0,
  clipEndSeconds = 30,
  captionsPath,
  showCaptions = true,
  captionPreset = "bold",
  title,
  accentColor = "#6366f1",
}) => {
  loadDefaultFonts();

  const src = staticFile(videoSrc);
  const offsetMs = clipStartSeconds * 1000;

  return (
    <OrganicLayer intensity="subtle" seed="podcastclip">
    <AbsoluteFill>
      {/* Video clip */}
      <VideoClip
        src={src}
        trimStartSeconds={clipStartSeconds}
        trimEndSeconds={clipEndSeconds}
      />

      {/* Captions with time offset */}
      {showCaptions && captionsPath && (
        <CaptionOverlay
          captionsSource={captionsPath}
          preset={captionPreset}
          position="bottom"
          offsetMs={offsetMs}
        />
      )}

      {/* Title at start */}
      {title && (
        <Sequence from={0} durationInFrames={90}>
          <SafeArea>
            <AbsoluteFill style={{justifyContent: "flex-start", alignItems: "center", paddingTop: 60}}>
              <AnimatedTitle
                text={title}
                fontSize={42}
                fontWeight={700}
                color="#ffffff"
                enterAnimation="slideDown"
                exitAnimation="fade"
                enterDuration={15}
                holdDuration={50}
                exitDuration={15}
                textShadow="0 2px 10px rgba(0,0,0,0.8)"
              />
            </AbsoluteFill>
          </SafeArea>
        </Sequence>
      )}

      {/* Progress bar */}
      <ProgressBar color={accentColor} height={3} />

      {/* Brand watermark */}
      <Watermark text={BRAND.handle} corner="topRight" opacity={0.5} fontSize={14} color="#ffffff" margin={30} />
      <CinemaGrain opacity={0.06} />
      <CinemaVignette opacity={0.5} />
    </AbsoluteFill>
    </OrganicLayer>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
